import { IconNames } from '@dixa/lib-shared-habla';
import { InstrumentType } from 'lib-analytics-types';

/** Various assets associated to the different instrument types. */
export const instrumentAssets: Record<
  InstrumentType,
  { icon: IconNames; title: string }
> = {
  metric: { icon: 'list-ol', title: 'Metrics' },
  chart: { icon: 'chart-bar', title: 'Chart' },
  table: { icon: 'th', title: 'Table' },
  presence: { icon: 'working', title: 'Presence' },
  ai_insight: { icon: 'ai', title: 'AI insight' },
};
